<template>
    <div class="auction container">
        <h2 class="page__title title title--m">Восстановление пароля</h2>
        <div class="auction__filters">
            <div v-if="windowWidth >= 1170"></div>
            <el-form ref="form" @submit.prevent.native="submit()">
                <el-form-item label="Пароль">
                    <el-input v-model="password" name="password" type="password" required></el-input>
                </el-form-item>
                <el-form-item label="Подтвердите пароль">
                    <el-input v-model="passwordConfirm" name="password_confirmation" type="password" required></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="disabled" native-type="submit">Отправить</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import width from "../../mixins/width";
import ApiService from "../../../../js/modules/ApiService";

export default {
    name: "ResetPassword",
    mixins: [width],
    props: ['email', 'csrfToken', 'token'],
    data: () => ({
        password: '',
        passwordConfirm: '',
        disabled: false,
    }),
    methods: {
        submit() {
            this.disabled = true;

            new ApiService().post('/password/reset', {
                password: this.password,
                password_confirmation: this.passwordConfirm,
                email: this.email,
                token: this.token,
                _token: this.csrfToken,
            })
                .then((response) => {
                    this.$appNotify.success(response.data.message);

                    setTimeout(() => {
                        window.location.replace('/');
                    }, 1000);
                })
                .catch((error) => {
                    this.$appNotify.error(error.response.data);
                })
        }
    }
}
</script>
